import { UpdateUserInfo, GetUserInfo } from "../types/user.types";
import axiosClient from "./axiosClient";

const refreshToken = () => {
  const url = "/users/refresh";
  return axiosClient.post(url);
};

const deleteUser = () => {
  const url = "/users/deleteAccount";
  return axiosClient.delete(url);
};

const deleteUserByEmail = () => {
  const url = "/users/deleteUserByEmail";
  return axiosClient.delete(url);
};

const getUserToken = () => {
  const url = "/users/index";
  return axiosClient.get(url);
};

export const getUserConfirmation = (confirmationId) => {
  const url = `/user-confirmation/${confirmationId}`;
  return axiosClient.get(url);
};

export const updateUserConfirmation = (confirmationId, params) => {
  const url = `/user-confirmation/${confirmationId}`;
  return axiosClient.post(url, params);
};

export const updateUserAssociate = (
  id: string,
  params: Record<string, unknown>
) => {
  return axiosClient.put(`/user-associate/${id}`, params);
};

const sentInvitation = (params) => {
  const url = "/users/invitation";
  return axiosClient.post(url, params);
};

const updateContact = () => {
  const url = "/users/updateContact";
  return axiosClient.post(url);
};

const getNameByReferral = (referralPath, referralCode) => {
  const url = `/referral/${referralPath}/${referralCode}`;
  return axiosClient.get(url);
};

const changeReferralURL = (referralPath, referralCode) => {
  const url = `/referral/${referralCode}`;
  return axiosClient.get(url, referralPath);
};

const preLoginApi = (params) => {
  const url = "/users/preLogin";
  return axiosClient.post(url, params);
};

const connectUserApi = () => {
  const url = "/users/connect";
  return axiosClient.post(url);
};

const reconnectUserApi = () => {
  const url = "/users/reconnect";
  return axiosClient.post(url);
};

const createUserApi = (params) => {
  const url = "/users/register";
  return axiosClient.post(url, params);
};

const sendResetPasswordRequestV2 = (params) => {
  const url = "/users/forgotPassword/v2";
  return axiosClient.post(url, params);
};

const confirmResetPasswordV2 = (params) => {
  const url = "/users/forgotPassword/v2/submit";
  return axiosClient.post(url, params);
};

const validateRecoverPasswordLink = (code: string, email: string) => {
  const url = `/users/forgotPassword/v2/validate?code=${encodeURIComponent(
    code
  )}&email=${encodeURIComponent(email)}`;
  return axiosClient.get(url);
};

const getMeApi = () => {
  const url = "/users/me";
  return axiosClient.get<any, GetUserInfo>(url);
};

const getIntercomTokenApi = () => {
  const url = "/users/intercomToken";
  return axiosClient.get<any, { appId: string; token: string }>(url);
};

const putMeApi = (params) => {
  const url = "/users/me";
  return axiosClient.put<any, UpdateUserInfo>(url, params);
};

const generateSMSVerification = (id, email) => {
  const url = `/users/generateSMSVerification/${id}/${email}`;
  return axiosClient.get(url);
};

const validateEmail = (id) => {
  const url = `/users/validate/email/${id}`;
  return axiosClient.get(url);
};

const validateEmailPasswordResetRequired = (email) => {
  const url = `/users/validate/email/${email}/password-reset-required`;
  return axiosClient.get(url);
};

const validatePhoneNumber = (id) => {
  const url = `/users/validate/phoneNumber/${id}`;
  return axiosClient.get(url);
};

const resendSMSVerification = (phoneNumber, email) => {
  const url = `/users/regenerateSMSVerification/${phoneNumber}/${email}`;
  return axiosClient.get(url);
};

const verifyPhoneNumber = (codeId, id, email) => {
  const url = `/users/verifyPhoneNumber/${codeId}/${id}/${email}`;
  return axiosClient.get(url);
};

const updateNotificationSettingApi = (params: {
  field: string;
  value: boolean;
}) => {
  const url = "/notification/configure";
  return axiosClient.post(url, params);
};

export {
  deleteUser,
  changeReferralURL,
  resendSMSVerification,
  updateContact,
  sentInvitation,
  refreshToken,
  getUserToken,
  getNameByReferral,
  verifyPhoneNumber,
  validateEmail,
  validatePhoneNumber,
  generateSMSVerification,
  putMeApi,
  getMeApi,
  preLoginApi,
  connectUserApi,
  createUserApi,
  reconnectUserApi,
  confirmResetPasswordV2,
  validateRecoverPasswordLink,
  sendResetPasswordRequestV2,
  validateEmailPasswordResetRequired,
  updateNotificationSettingApi,
  deleteUserByEmail,
  getIntercomTokenApi,
};
